import { Checkbox, FormControlLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import './i-checkbox.component.scss';

export interface ICheckboxItem {
    value: any,
    name: string
}

export interface ICheckboxProps {
    label: string,
    name: string,
    value?: string,
    itemList?: string[], // ICheckboxItem[],
    type?: string
    onChangeEvent?: any
    required?: boolean;
    rules?: any;
    defaultChecked: boolean;
}

const ICheckbox = (props: ICheckboxProps) => {
    const { control, setValue } = useFormContext();
    const onChangeEvent = (e: any) => {
        const value = e.target.checked;
        setValue(props.name, value);
        if (props.onChangeEvent) {
            props.onChangeEvent(e);
        }
    }

    return  <FormControlLabel
    label={props.label}
    control={
      <Controller
        name={props.name}
        control={control}
        defaultValue={false}
        render={({ field }) => <Checkbox {...field} defaultChecked={props.defaultChecked} onChange={onChangeEvent}/>}
      />
    }
  />
    
    
    // <FormControl fullWidth>
    //     <Controller
    //         control={control}
    //         name={props.name}
    //         rules={{
    //             required: props.required,
    //             ...props.rules
    //           }}
    //         render={({ field }) => (        <FormControlLabel
    //             control={
    //               <Checkbox checked={checkedValue} onChange={onChangeEvent} name={props.name} />
    //             }
    //             label={props.label}
    //           />
            
            
            
            
            // <Checkbox                {...field}
            //     {...register(props.name)}
            //     className="i-checkbox"
            //     id={props.name}
            //     size="small"
            //     onChange={onChangeEvent}
            //     label={props.label}
            // />
    //         )}
    //     />
    // </FormControl>

};

export default ICheckbox;